import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CertificationService } from '../_services';
import * as CertificationActions from '../_actions/certification';

@Injectable({
  providedIn: 'root',
})
export class CertificationEffects {
  loadCertifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationActions.loadCertifications),
      mergeMap(() =>
        this.certificationService.getCertifications().pipe(
          map((certifications) =>
            CertificationActions.loadCertificationsSuccess({ certifications })
          ),
          catchError((error) => of(CertificationActions.loadCertificationsFailure({ error })))
        )
      )
    )
  );

  addCertification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationActions.addCertification),
      mergeMap(({ certification }) =>
        this.certificationService.saveCertification(certification).pipe(
          map((savedCertification) =>
            CertificationActions.addCertificationSuccess({ certification: savedCertification })
          ),
          catchError((error) => of(CertificationActions.addCertificationFailure({ error })))
        )
      )
    )
  );

  updateCertification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationActions.updateCertification),
      mergeMap(({ certification }) =>
        this.certificationService.saveCertification(certification).pipe(
          map((updatedCertification) =>
            CertificationActions.updateCertificationSuccess({ certification: updatedCertification })
          ),
          catchError((error) => of(CertificationActions.updateCertificationFailure({ error })))
        )
      )
    )
  );

  deleteCertification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificationActions.deleteCertification),
      mergeMap(({ id }) =>
        this.certificationService.deleteCertification(id).pipe(
          map(() => CertificationActions.deleteCertificationSuccess({ id })),
          catchError((error) => of(CertificationActions.deleteCertificationFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private certificationService: CertificationService
  ) {}
}
